/* 布局 */
//前台
import Layout from "@views/layout";

const questionanwserRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
            path: "questionanwser",
            name: "QUESTIONANWSER",
            meta: {
                title: "问卷回答",
                sort: 1,
            },
            component: () => import("@views/business/questionanwser/index.vue"),
            redirect: {
                name: "QUESTIONANWSER_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "QUESTIONANWSER_LIST",
                    meta: {
                        title: "问卷回答",
                        sort: 2,
                        keepAlive: true
                    },
                    component: () => import("@views/business/questionanwser/list.vue"),
                },
                {
                    path: "add",
                    name: "QUESTIONANWSER_ADD",
                    meta: {
                        title: "新增调查问卷回答",
                        parentPath: '/business/questionanwser/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionanwser/form.vue"),
                },
                {
                    path: "edit",
                    name: "QUESTIONANWSER_EDIT",
                    meta: {
                        title: "编辑调查问卷回答",
                        parentPath: '/business/questionanwser/list',
                        operate: true,
                    },
                    component: () => import("@views/business/questionanwser/form.vue"),
                },
            ],
        },


    ],
};

export default questionanwserRouter;
